export default "__VITE_ASSET__BOEKjD1a__"